import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import CustomStyledMenu from "../Menu/CustomStyledMenu";
import SearchField from "../InputFields/SearchField";
import TypographyInline from "../Typography/TypographyInline";
import { Button } from "../Buttons";
import IconComponent from "../Icon/IconComponent";
import { GREY } from "../../utils/constants/colors";
import { fontSize, fontWeight, ICON_LABELS } from "../../utils/constants/UI";
import { STRINGS } from "./strings";
import classes from "./Table.module.css";

const ConnectedInboxesMenu = ({ anchorEl, open, onClose, emails = [] }) => {
  const [search, setSearch] = useState("");

  const filteredEmails = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return emails;
    return emails.filter((email) => email?.toLowerCase().includes(query));
  }, [emails, search]);

  const handleClose = () => {
    setSearch("");
    onClose();
  };

  return (
    <CustomStyledMenu
      noMargin
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={open}
      width={"300px"}
      onClose={handleClose}
    >
      <div className={classes.connectedInboxesContain}>
        <Box className={classes.connectedInboxesHeader}>
          <TypographyInline
            label={STRINGS.CONNECTED_INBOXES}
            size={"md"}
            fontWeight={fontWeight.MEDIUM}
            color={GREY.PRIMARY}
          />
        </Box>
        <Box className={classes.connectedInboxesBody}>
          <Box className={classes.connectedInboxesSearch}>
            <SearchField
              size={"sm36"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              placeholder={STRINGS.SEARCH_INBOXES}
            />
          </Box>
          <Box className={classes.connectedInboxesList}>
            {filteredEmails.map((email) => (
              <Box key={email} className={classes.connectedInboxRow}>
                <IconComponent
                  iconLabel={ICON_LABELS.EMAIL}
                  color={GREY.TERTIARY}
                  fontSize={fontSize.MD}
                />
                <div style={{ minWidth: 0, flex: 1 }}>
                  <TypographyInline
                    isNoWrap
                    className={classes.connectedInboxEmailText}
                    label={email}
                    size={"sm"}
                    fontWeight={fontWeight.REGULAR}
                    color={GREY.SECONDARY}
                  />
                </div>
              </Box>
            ))}
          </Box>
        </Box>
        <Box className={classes.connectedInboxesFooter}>
          <Button
            label={STRINGS.CLOSE}
            variant={"ghost"}
            size={"sm36"}
            onClick={handleClose}
          />
        </Box>
      </div>
    </CustomStyledMenu>
  );
};

export default ConnectedInboxesMenu;